import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import DetailPage from "@/pages/detail/page";
import AdminPage from "@/pages/admin/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/accommodation/:id",
    element: <DetailPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
